import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-50a4b6fb"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "panel" }

import { MenuOutlined } from '@ant-design/icons-vue';
import TopPanelBalance from '@/components/TopPanelBalance.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'TopPanelMobile',
  emits: ['toggleMenu'],
  setup(__props, { emit }) {


const toggleMenu = () => emit('toggleMenu');

return (_ctx: any,_cache: any) => {
  const _component_UiButton = _resolveComponent("UiButton")!
  const _component_VSpacer = _resolveComponent("VSpacer")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_UiButton, {
      class: "button-menu",
      type: "text",
      onClick: toggleMenu
    }, {
      default: _withCtx(() => [
        _createVNode(_unref(MenuOutlined))
      ]),
      _: 1
    }),
    _createVNode(_component_VSpacer),
    _createVNode(TopPanelBalance, { class: "d-flex align-center" })
  ]))
}
}

})